import React, { FC } from 'react';

import { ReactComponent as LogoImage } from 'shared/assests/img/navbar/logo_new.svg';
import { Wrapper } from './style';

const Logo: FC = () => {
  return (
    <Wrapper>
      <LogoImage />
    </Wrapper>
  );
};

export default Logo;
